const BaseError = require('make-error').BaseError;

//put this in lib_errors?
class ValidationError extends BaseError {
    constructor(errorMessage = 'Validation failed', problems) {
        super(errorMessage);
        this.data = problems;
        this._isUserError = true;
    }
}

module.exports = ValidationError;
